<template>
	<main id="paxExpress" class="pax_global">
		<HeaderTab :title="$t('pax.suggestions_pax')" :icon="['fal', 'horse']" />
		<div id="paxReverse" class="container-fluid">
			<div class="row justify-content-center">
				<ChoixLangue v-show="step === 1" @langue_choosed="goToCountry"/>
				<ChoixCountry v-show="step === 2" @country_choosed="goToPax"/>
				<template v-if="step > 2">
					<div class="col bstallion">
						<MaresSuggestion :mares_selected.sync="mares_selected" :pax_suggestion="true"></MaresSuggestion>
					</div>
				</template>
			</div>
		</div>
	</main>
</template>


<script type="text/javascript">
	import UserMixin from '@/mixins/User.js'
	import Navigation from '@/mixins/Navigation.js'
	import PaxMixin from '@/mixins/Pax.js'
	import Config from '@/mixins/Config.js'
	import Window from '@/mixins/Window.js'

	export default {
		name: "PaxSuggestion",
		mixins: [UserMixin, Navigation, PaxMixin, Config, Window],
		data () {
			return {
				mares_selected: [],
				step: 1,
			}
		},

		beforeRouteUpdate(to, from, next) {
			// Restaure l'étape depuis la query URL (retour/avant navigateur),
			// en retombant sur la configuration langue/pays quand la query est absente
			this.step = this.computeStep(to.query)
			next()
		},

		created() {
			this.init_component()
		},

		methods: {
			init_component() {
				document.querySelector('html').classList.remove('no_scroll')
				this.mares_selected = []
				this.step = this.computeStep(this.$route.query)
			},

			/**
			 * Dérive l'étape affichée à partir de la query URL, puis de la configuration langue/pays.
			 * @param {Object} query Query de la route (attend éventuellement `pax_step`)
			 * @return {Number} Numéro d'étape : 1 = langue, 2 = pays, 3 = juments
			 */
			computeStep(query) {
				if (query.pax_step === 'mares') {
					return 3
				}
				if (query.pax_step === 'country') {
					return 2
				}

				const lang = this.getConfig('lang')
				const country = this.getConfig('country')
				if (lang && country) {
					return 3
				}
				if (lang && !country) {
					return 2
				}
				return 1
			},

			goToCountry() {
				this.$router.push({ name: 'paxSuggestion', query: { pax_step: 'country' } })
			},

			goToPax() {
				this.$router.push({ name: 'paxSuggestion', query: { pax_step: 'mares' } })
			},
		},

		components: {
			HeaderTab: () => import('@/components/HeaderTab'),
			MaresSuggestion: () => import('@/components/Pax/MaresSuggestion'),
			ChoixLangue: () => import('@/components/Pax/ChoixLangue'),
			ChoixCountry: () => import('@/components/Pax/ChoixCountry'),
		}
	};
</script>
